import React from 'react';
import { motion } from 'framer-motion';
import styles from './HeartLoader.module.scss';

const HEART_PATH =
  'M11.6193 5.41417L12 5.8612L12.3807 5.41417C13.3789 4.24197 14.9114 3.5 16.5 3.5C19.3039 3.5 21.5 5.69614 21.5 8.5C21.5 10.2258 20.7284 11.8307 19.2692 13.6147C17.8043 15.4057 15.6992 17.3155 13.1141 19.6596L13.1134 19.6603L11.9987 20.675L10.8863 19.67L10.8852 19.669L10.8735 19.6583C8.29414 17.3144 6.19348 15.4055 4.73088 13.6161C3.27162 11.8308 2.5 10.2258 2.5 8.5C2.5 5.69614 4.69614 3.5 7.5 3.5C9.08861 3.5 10.6211 4.24197 11.6193 5.41417Z';

const HeartLoader = ({
  className = '',
  progress = 100, // Always show as progress indicator, default to 100
  noRise = false, // New prop to control rising animation
  pulse = false, // New prop to control pulsating animation
}) => {
  // Clamp progress between 0 and 100
  const clampedProgress = Math.max(0, Math.min(100, progress));

  // Define animation variants based on props
  const animationVariants = {
    initial: {
      opacity: 0,
      y: noRise ? 0 : 60,
      scale: 0.8,
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: pulse ? [1, 1.1, 1] : 1,
    },
    exit: {
      opacity: 0,
      y: noRise ? 0 : -30,
      scale: 0.9,
    },
  };

  const transitionConfig = {
    duration: 5,
    ease: [0.25, 0.46, 0.45, 0.94], // Custom cubic-bezier for smooth, dynamic motion
    opacity: { duration: 0.4, ease: [0.4, 0, 0.2, 1] },
    y: { duration: noRise ? 0.4 : 5, ease: [0.25, 0.46, 0.45, 0.94] },
    scale: pulse
      ? {
          duration: 1.2,
          repeat: Infinity,
          ease: [0.4, 0, 0.6, 1],
          repeatType: 'reverse',
        }
      : { duration: 0.6, ease: [0.34, 1.56, 0.64, 1] }, // Bouncy scale effect
  };

  return (
    <motion.div
      className={`${styles.heartLoader} ${className}`}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={animationVariants}
      transition={transitionConfig}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className={styles.svgHeart}
      >
        <g clipPath="url(#clip0_heart_loader)">
          {/* Heart fill (progress) */}
          <path
            d={HEART_PATH}
            fill="#FEC738"
            className={styles.heartFill}
            style={{ clipPath: `inset(${100 - clampedProgress}% 0 0 0)` }}
          />
          {/* Heart outline */}
          <path
            d={HEART_PATH}
            stroke="#404040"
            strokeWidth="1"
            fill="none"
            className={styles.heartOutline}
          />
        </g>
        <defs>
          <clipPath id="clip0_heart_loader">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </motion.div>
  );
};

export default HeartLoader;
